export enum CodeDisplayMode {
  none,
  qr,
  barcode,

}
